module.exports = __webpack_public_path__ + "static/media/loading.45722f19.png";